const handleEnterKey = cb => e => {
  if (e.key === "Enter") cb(e);
};

export default handleEnterKey;
